module.exports = __webpack_public_path__ + "img/markqueue-orthopedic.8f08d6eb.png";